module.exports = __webpack_public_path__ + "static/img/02_silver120.327a9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/02_silver120.png
// module id = qYj/
// module chunks = 12